import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconDragSmall({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M7.5 6.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7zm0-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7zm0-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7z"/>
        </svg>
    );
}

export default IconDragSmall;
